module.exports = __webpack_public_path__ + "img/process.956e6145.png";